import { format, parse } from 'date-fns'
import type { FC } from 'react'
import styled from 'styled-components'

import H6 from '@/components/H6'
import DateInput from '@/components/input/DateInput'
import Select from '@/components/Select'
import TextInput from '@/components/TextInput'
import RemoveButton from '@/components/VerifyCredit/RemoveButton'
import type { CompanyCCJ as Fields, CompanyCCJState } from '@/types/Activity'

const Container = styled.div`
  display: grid;
  gap: 10px;
`

const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
`

const SelectOptionsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
`

const CourtDetailsContainer = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 20px;
`

interface Props {
  values: Fields
  onChangeValues: (fields: Fields) => void
  onRemove: () => void
  itemNumber: number
}

const OrganisationCCJFields: FC<Props> = ({
  values,
  onChangeValues,
  onRemove,
  itemNumber,
}) => (
  <Container>
    <HeaderContainer>
      <div>
        <H6>CCJ {itemNumber}</H6>
      </div>
      <div>
        <RemoveButton onRemove={onRemove} />
      </div>
    </HeaderContainer>
    <div>
      <SelectOptionsRow>
        <div>
          <Select<CompanyCCJState>
            onSelect={state =>
              onChangeValues({
                ...values,
                state,
              })
            }
            options={[
              { label: 'Active', value: 'Active' },
              { label: 'Satisfied', value: 'Satisfied' },
            ]}
            selectedValue={values.state}
            label="State"
          />
        </div>
      </SelectOptionsRow>
    </div>
    <div>
      <CourtDetailsContainer>
        <div>
          <DateInput
            label="Court date"
            date={parse(values.courtDate, 'yyyy-MM-dd', new Date())}
            setDate={courtDate =>
              onChangeValues({
                ...values,
                courtDate: format(courtDate as Date, 'yyyy-MM-dd'),
              })
            }
          />
        </div>
        <div>
          <TextInput
            type="number"
            value={values.amount}
            label="Amount"
            name="amount"
            onChange={amount =>
              onChangeValues({
                ...values,
                amount: parseInt(amount),
              })
            }
          />
        </div>
      </CourtDetailsContainer>
    </div>
  </Container>
)

export default OrganisationCCJFields
